import { render } from "./Main.vue?vue&type=template&id=5ac03b8f"
const script = {}
script.render = render

export default script